import { forwardRef } from 'react'

import { Input } from '../Input/index.js'
import { FormControlLayout } from './FormControlLayout.js'
import { FormControlInputProps } from './types.js'
import { extractLayoutProps } from './utils.js'

export const FormControlInput = forwardRef<
  HTMLInputElement,
  FormControlInputProps
>((props, ref) => {
  const { layoutProps, inputProps } = extractLayoutProps(props)

  return (
    <FormControlLayout {...layoutProps}>
      <Input ref={ref} {...inputProps} />
    </FormControlLayout>
  )
})
